import { variables, $ } from './common/variables';
import { cl, ajax } from './common/functions';

import { inputFile } from './components/input-file';
import { selectInit } from './components/select';
import { historyReplace } from './components/history-replace';
import { toggleTab } from './components/toggle-tab'
import { toggleEntities } from './components/toggle-entities'
import { fieldEdit } from './components/field-edit';
import { fieldDelete } from './components/field-delete';
import { fieldCreateUtilities, fieldCreate } from './components/field-create';
import { jsonExport } from './components/json-export';
import { shortcodeGenerator } from './components/shortcode-generator';
import { optionsActions } from './components/options-actions';

window.addEventListener('DOMContentLoaded', event => {

  inputFile(); // Input file

  selectInit(); // Selects

  historyReplace(); // Prevent forms to be sent on refresh

  toggleTab(); // Toggle menu

  if (variables.hook === 'toplevel_page_glanum-leaflet-manage') {
    jsonExport(); // Export data (json format)

    shortcodeGenerator();
  }

  if (variables.hook === 'glanum-leaflet_page_glanum-leaflet-manage-entities') {
    const entityContainer = document.querySelectorAll('.section__entity');
    !!entityContainer.length && toggleEntities(entityContainer);
    fieldCreateUtilities();
  }

  if (variables.hook === 'glanum-leaflet_page_glanum-leaflet-manage-options') {
    optionsActions();
  }

  if (variables.hook === 'glanum-leaflet_page_glanum-leaflet-manage-entities' || variables.hook === 'glanum-leaflet_page_glanum-leaflet-manage-types' || variables.hook === 'glanum-leaflet_page_glanum-leaflet-manage-options') {
    const fields = document.querySelectorAll('.ajax__edit');
    !!fields.length && fieldEdit(fields);

    const deleteBtn = document.querySelectorAll('a.gl__action');
    !!deleteBtn.length && fieldDelete(deleteBtn);

    fieldCreate();
  }
});
